module.exports = __webpack_public_path__ + "media/images/info-blue-c8f3a2429b62e622322d40b53d7e16c7.svg";